import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';

const PaymentPending = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { user, loading } = useAuth();
  const paymentId = searchParams.get('payment_id');

  const handleRetry = () => {
    navigate('/access-denied');
  };

  const handleLogin = () => {
    navigate('/login');
  };

  if (loading) {
    return (
      <LoadingSpinner
        label="Cargando…"
        height="100vh"
        style={{ background: 'var(--bg-primary)', color: 'var(--text-primary)' }}
      />
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--navy-deep, #0a1a2a) 0%, var(--navy-light, #162a3d) 100%)',
      color: 'white',
      fontFamily: "'Segoe UI', Roboto, sans-serif",
      padding: '2rem',
      textAlign: 'center'
    }}>
      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(10px)',
        padding: '3rem',
        borderRadius: '20px',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 8px 32px 0 rgba(0, 0, 0, 0.37)'
      }}>
        <div style={{ fontSize: '5rem', marginBottom: '1rem' }}>⏳</div>
        <h1 style={{
          margin: '0 0 1rem 0',
          fontSize: '2rem',
          background: 'linear-gradient(90deg, #f59e0b 0%, #fbbf24 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent'
        }}>
          Pago en Proceso
        </h1>
        <p style={{
          color: '#cbd5e1',
          lineHeight: '1.6',
          marginBottom: '1.5rem',
          fontSize: '1rem'
        }}>
          Tu pago está siendo procesado. Algunos pagos en efectivo o transferencias pueden tomar hasta 48 horas hábiles en confirmarse.
        </p>
        {paymentId && (
          <p style={{
            color: '#64748b',
            fontSize: '0.85rem',
            marginBottom: '1.5rem'
          }}>
            ID de transacción: <code style={{ background: 'rgba(255,255,255,0.1)', padding: '2px 6px', borderRadius: '4px' }}>{paymentId}</code>
          </p>
        )}
        <div style={{
          background: 'rgba(245, 158, 11, 0.1)',
          border: '1px solid rgba(245, 158, 11, 0.3)',
          borderRadius: '12px',
          padding: '1rem',
          marginBottom: '1.5rem',
          textAlign: 'left'
        }}>
          <h4 style={{ margin: '0 0 0.5rem 0', color: '#f59e0b', fontSize: '0.9rem' }}>
            📋 ¿Qué sigue?
          </h4>
          <ul style={{ margin: 0, paddingLeft: '1.25rem', color: '#cbd5e1', fontSize: '0.85rem' }}>
            <li>Recibirás un email de confirmación cuando se apruebe tu pago</li>
            <li style={{ marginTop: '0.5rem' }}>Tu licencia se activará automáticamente</li>
            <li style={{ marginTop: '0.5rem' }}>Puedes volver a iniciar sesión más tarde</li>
          </ul>
        </div>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            onClick={handleRetry}
            style={{
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              border: 'none',
              padding: '12px 24px',
              color: 'white',
              borderRadius: '50px',
              fontSize: '0.95rem',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'transform 0.2s, box-shadow 0.2s',
              boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Ver Planes
          </button>
          {!user && (
            <button
              onClick={handleLogin}
              style={{
                background: 'transparent',
                border: '2px solid rgba(255, 255, 255, 0.3)',
                padding: '10px 24px',
                color: 'white',
                borderRadius: '50px',
                fontSize: '0.95rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s'
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = 'transparent';
              }}
            >
              Iniciar Sesión
            </button>
          )}
        </div>
      </div>
      <div style={{ marginTop: '2rem', color: '#64748b', fontSize: '0.8rem' }}>
        Vortex EXANI-II © {new Date().getFullYear()}
      </div>
    </div>
  );
};

export default PaymentPending;
